import { useTranslation } from "react-i18next";
import { IconAward01 } from "@pentabd/icons";
import { Header } from "@pentabd/ui";
import { CommitteeCreatePageProps } from "@type/procurements/committee";
import { useParams } from "react-router-dom";
import { ROUTES } from "@constants/routes";

export default function CreateCommitteeHeader({
  committeeState,
}: CommitteeCreatePageProps) {
  const { id } = useParams();
  const { t } = useTranslation();
  const breadcrumbs = [
    {
      icon: <IconAward01 fill="dark" size="20" />,
    },
    {
      label: t("COMMITTEE.BREADCRUMBS.FIRST_STEP"),
      link: ROUTES.PROCUREMENT.COMMITTEE,
    },
    {
      label: `${
        committeeState?.getSingleData?.name ||
        t("COMMITTEE.BREADCRUMBS.SECOND_STEP")
      }`,
    },
  ];

  const headerText = {
    header: `${
      id ? committeeState?.getSingleData?.name : t("COMMITTEE.LABEL")
    }`,
  };

  return <Header headerText={headerText} breadcrumbs={breadcrumbs} />;
}
